export default function imageTextCard(
  widgetNameVariable,
  widgetOptsVariable,
  { titleIsH1 = false } = {},
) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = `${widgetName}-container`;
  const widgetTitleTag = titleIsH1 ? 'h1' : 'h2';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createimageTextCard(data.items[0]);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createimageTextCard(widgetData) {
    const { Title, Description, ImageWithPath } = widgetData;
    const $imageTextCardWidget = $widget.find('.card-widget-item');

    $imageTextCardWidget.replaceWith(`
      <div class="imageTextCard-img" style="background-image: url('${ImageWithPath}')"></div>
      <div class="imageTextCard-text-box">
        <${widgetTitleTag} class="imageTextCard-title">${Title}</${widgetTitleTag}>
        <div class="imageTextCard-description">${Description}</div>
      </div>
  `);
  }
}
